module.exports = __webpack_public_path__ + "static/media/ic-none-view-24.54089301.svg";